// import React from 'react';
import React from 'react'

import './assets/css/App.css';
import Container from './modules/Container';

class App extends React.Component {
  render() {
    return (
      <div>
        <script src="./assets/js/vendor/typelighter.js"></script>
        <Container/>
      </div>
      
    );
  }
}

export default App;
